import api from "./api";

export const authService = {
  register: (data: {
    first_name: string;
    last_name: string;
    email: string;
    username: string;
    password: string;
    password_confirmation: string;
  }) => api.post("/auth/register", data),

  login: (data: { email: string; password: string }) =>
    api.post("/auth/login", data),

  me: () => api.get("/auth/me"),
  logout: () => api.post("/auth/logout"),
  refresh: () => api.post("/auth/refresh"),

  updateProfile: (data: object) => api.put("/profile", data),
  updatePassword: (data: object) => api.put("/profile/password", data),

  // ── Password reset (OTP flow) ───────────────────────────────────────────────
  /** Step 1 — send a 6-digit OTP to the email */
  forgotPassword: (email: string) =>
    api.post("/auth/forgot-password", { email }),

  /** Step 2 — verify the OTP is valid (does not reset yet) */
  verifyOtp: (email: string, otp: string) =>
    api.post("/auth/verify-otp", { email, otp }),

  /** Step 3 — supply the new password along with the verified OTP */
  resetPassword: (
    email: string,
    otp: string,
    password: string,
    password_confirmation: string,
  ) =>
    api.post("/auth/reset-password", {
      email,
      otp,
      password,
      password_confirmation,
    }),
};
